export const NEW_CHOOSE_VOYAGE_ADD_TRACKED_SAILINGS = 'NEW_CHOOSE_VOYAGE_ADD_TRACKED_SAILINGS';
